<script lang="js" setup>
import { useLocalePath } from '#imports'
import { useFutureStore } from '~/store/future'

import IconFav from '@/assets/images/common/icon-fav-trade.svg'
import IconFire from '@/assets/images/spot/ic-fire.svg'
import LR from '~/components/spot/favSymbols/LR.vue'

const future = useFutureStore()
const localePath = useLocalePath()

future.getHotSymbols()

const list = computed(() => [
  { list: future.favIds, icon: IconFav, type: 'future', class: 'max-w-[60vw] after:content-[""] after:block after:h-4 after:w-px after:bg-border after:relative after:right-0' },
  { list: future.hotSymbols.map(i => i.instrumentId), icon: IconFire, type: 'hot', class: 'overflow-hidden' },
])
</script>

<template>
  <div class="h-[46px] px-3 bg-fillPagePrimary flex items-center gap-3 min-w-[1280px] max-w-[100vw]">
    <ClientOnly>
      <template v-for="row in list" :key="row.type">
        <div v-if="row.list.length > 0" class="flex items-center" :class="row.class">
          <component :is="row.icon" class="w-6 h-6 text-orange3" />
          <LR class="px-3" content-class="h-[46px]">
            <div class="flex items-center gap-2">
              <NuxtLink
                v-for="i in row.list" :key="i"
                class="px-2 text-textSecondary text-xs font-medium items-center flex h-[38px] cursor-pointer rounded hover:bg-pageTertiary transition-all"
                :to="localePath(`/futures/${future.getInfo(i).code}`)"
              >
                <span class="pe-1">{{ future.getInfo(i).displayName }}</span>
                <span
                  class="font-normal" :class="{
                    'text-red3': future.getOverviewByCode(i).r < 0,
                    'text-green3': future.getOverviewByCode(i).r > 0,
                  }"
                >{{ future.getOverviewByCode(i).rt }}</span>
              </NuxtLink>
            </div>
          </LR>
        </div>
      </template>
    </ClientOnly>
  </div>
</template>
